// @ts-check
import { initSchema } from '@aws-amplify/datastore';
import { schema } from './schema';

const AssessmentType = {
  "BEAUTY": "BEAUTY",
  "ED": "ED",
  "HAIR_LOSS": "HAIR_LOSS",
  "WEIGHT_LOSS": "WEIGHT_LOSS",
  "SLEEP": "SLEEP",
  "PAIN_CREAM": "PAIN_CREAM",
  "JOINT_HEALTH": "JOINT_HEALTH",
  "TESTOSTERONE": "TESTOSTERONE"
};

const Status = {
  "SEE_DOCTOR": "SEE_DOCTOR",
  "PENDING_REVIEW": "PENDING_REVIEW",
  "UNPAID": "UNPAID",
  "PAID": "PAID",
  "SHIPPED": "SHIPPED"
};

const Schedule = {
  "OTC": "OTC",
  "PRESCRIPTION": "PRESCRIPTION"
};

const PrescriptionStatus = {
  "PENDING_REVIEW": "PENDING_REVIEW",
  "APPROVED": "APPROVED",
  "DENIED": "DENIED",
  "EXPIRED": "EXPIRED"
};

const Sex = {
  "MALE": "MALE",
  "FEMALE": "FEMALE",
  "OTHER": "OTHER"
};

const AppointmentStatus = {
  "REQUESTED": "REQUESTED",
  "CONFIRMED": "CONFIRMED",
  "DECLINED": "DECLINED",
  "CANCELLED": "CANCELLED"
};

const VerificationStatus = {
  "PENDING": "PENDING",
  "VERIFIED": "VERIFIED",
  "FAILED": "FAILED"
};

const { PatientVerification, User, Patient, PrescriptionRenewal, PainLog, Availability, Appointment, Assessment, TreatmentPlan, Medication, Cart, CartItem, ContactSubmission, CreateAssessmentResponse, PreAuthSessionResponse, ChargeResponse, VerificationSessionResponse, VerificationStatusResponse, CheckoutSessionResponse, WebhookResponse, GeneratePrescriptionResponse, EmailResponse, CheckoutSession } = initSchema(schema);

export {
  PatientVerification,
  User,
  Patient,
  PrescriptionRenewal,
  PainLog,
  Availability,
  Appointment,
  Assessment,
  TreatmentPlan,
  Medication,
  Cart,
  CartItem,
  ContactSubmission,
  AssessmentType,
  Status,
  Schedule,
  PrescriptionStatus,
  Sex,
  AppointmentStatus,
  VerificationStatus,
  CreateAssessmentResponse,
  PreAuthSessionResponse,
  ChargeResponse,
  VerificationSessionResponse,
  VerificationStatusResponse,
  CheckoutSessionResponse,
  WebhookResponse,
  GeneratePrescriptionResponse,
  EmailResponse,
  CheckoutSession
};